/* eslint-disable camelcase */
export default {
	emptyData: '暂无数据',
	add: '添加',
	delete: '删除',
	query: '查询',
	export: '导出',
	queryCondition: '查询条件',
	choose: '请选择',
	warningTitle: '提示',
	ok: '确定',
	cancel: '取消',
	operate: '操作',
	yes: '是',
	no: '否',
	to: '至',
	total: '共',
	days: '天',
	day: '天',
	close: '关闭',
	dateFormat: 'yyyy/MM/dd',
	totalAmount: '金额合计',
	export_may_take_a_long_time: '该下载可能需要较长时间，请等待。（不要关闭页面或重复点击按钮）',
	prompt: '提示',
	definite: '确定',
	confirm: {
		delete: '确定要删除吗？',
		export: '导出可能需要较长时间，请等待。（不要关闭页面或重复点击导出按钮）',
		opinion: '驳回必须填写意见/缺陷。',
		sendMail: '您确定要发送催办邮件吗?'
	},
	message: {
		dataEmpty: '表格数据为空，无法导出。',
		deleteSuccess: '删除成功！',
		deleteCancel: '删除已取消',
		exportCancel: '导出已取消',
		up: '已到达查询结果当前页的第一项',
		down: '已到达查询结果当前页的最后一项',
		date: '结束日期不能小于开始日期',
		approvalAgree: '请选择审批同意的单据',
		approvalDisagree: '请选择审批不同意的单据',
		approvalFundsDisagree: '请选择驳回的单据',
		transferSuccess: '转交成功',
		sendSuccess: '发送成功，申请单ID [{0}]',
		recognizeSuccess: '识别成功',
		recognizeFailed: '识别失败',
		exportError: '导出的数据不允许超出2000行，请提高您的搜索精度或联系管理员8001帮助。',
		agreeSuccess: '审批成功',
		saveSuccess: '保存成功',
		submitSuccess: '提交成功',
		dialogError: '弹窗被阻止，请检查你的浏览器设置后重新再试。',
		doneAudit: '该单已被当前用户审批，不能重复操作。',
		tips: '温馨提示'
	},
	warning: {
		tencentCriterion:
			'我已了解并承诺遵守《腾讯阳光行为准则》和报销相关规定的要求，我承诺我提交的报销信息与相关报销单据都是真实且符合公司报销相关规定的。',
		footerDevInfo: '腾讯公司 财经线-S系统财务管理-业务开发中心, 技术支持: IT热线-财经系统支持(8001)'
	},
	tips: {
		contract: '多个合同号用;分隔',
		market: '多个活动单号用;分隔',
		applyPriority: '该申请单的优先级为[高]'
	},
	status: {
		draft: '草稿',
		processing: '系统处理中',
		relateApprovalAudit: '相关审批人审批',
		businessFinancialAudit: '业务线财管审批',
		businessDeptHeadAudit: '业务部门负责人审批',
		coopDeptHeadAudit: '产业生态合作部负责人审批',
		audited: '审批完成',
		cancelled: '已取消',
		effective: '已完成',
		terminated: '已终止',
		stopped: '已中止',
		deleted: '已删除',
		pendingAcceptance: '待验收',
		acceptance: '已验收',
		vendorConfirm: '供应商确认',
		purchaserConfirm: '采购确认',
		leaderAudit: '直属Leader审批',
		centerChargerAudit: '中心负责人审批',
		priceLibrary: '已进价格库',
		finished: '已完成'
	},
	header: {
		finance_line: '财经线',
		business_procurement_platform: '业务采购平台',
		stars: '星辰',
		welcome: '欢迎您，',
		feedback: '意见反馈',
		OA_home: 'OA首页',
		drop_out: '退出'
	},
	MaterialCategory: '物料类别',
	DemandOrderNumber: '需求单号',
	DemandDepartment: '需求部门',
	DemandLocation: '需求地点',
	Buyer: '采购员',
	GroupLeader: '小组负责人',
	HeadOfCenter: '中心负责人',
	WarningLevel: '预警级别',
	Inquire: '查询',
	ApprovalCompletionTime: '审批完成时间',
	ExpirationTimeBuyer: '到期时间（采购员）',
	ExpirationTimeGroupleader: '到期时间（小组负责人）',
	ExpirationTimeHeadOfCenter: '到期时间（中心负责人）',
	CurrentWarningLevel: '目前预警级别',
	FollowUp: '跟踪关注',
	ApplyDepartment: '申请部门',
	Applicant: '申请人',
	Founder: '创建人',
	CreationTime: '创建时间',
	State: '状态',
	Draft: '草稿',
	Examination: '审批中',
	Have_been_approval: '已审批',
	The_cancellation: '已作废',
	MaterialCode: '物料编码',
	MaterialDescription: '物料名称',
	BusinessScenario: '业务场景',
	IntendedSupplier: '意向供应商',
	Total_demand_order: '需求单总额',
	Associated_decision_order_number: '关联决策单号',
	ProjectLabel: '项目标签',
	Brand: '品牌',
	Model: '型号',
	AbstractType: '抽象类型',
	Asset_Light_or_Not: '是否轻资产',
	PriceVendor: '价格库供应商',
	Package_agreement: '一揽子协议',
	Lines_of_business: '业务线',
	Warehouse_room: '仓库机房',
	contract_of_sale: '销售合同',
	Project_code: '立项编码',
	Advanced_search: '高级搜索',
	Ordinary_search: '普通搜索',
	Demand_order_title: '需求标题',
	Demand_order_number: '需求单编号',
	Business_purpose: '业务场景',
	Business_Line: '业务线',
	Associated_Decision_Order_Number: '关联决策单号',
	Total_amount_of_demand_order_RMB: '需求单总金额（人民币)',
	Basic_Information: '基本信息',
	founder: '创建人',
	Relevant_approvers: '相关审批人',
	Estimated_delivery: '预计交期',
	Currency: '币种',
	Total_amount_of_demand_order: '需求单总金额',
	Statement_of_needs: '需求说明',
	center: '中心',
	Demand_detail_information: '需求明细信息',
	Remarks: '备注',
	Expected_delivery_time: '期望货期',
	Shipping_address: '收货地址',
	Computer_room_name: '机房名称',
	Standard_delivery_period: '标准货期',
	user: '使用人',
	product: '产品',
	Cost_Center: '成本中心',
	Amount_subtotal: '金额小计',
	exchange_rate: '汇率',
	Exchange_rate_date: '汇率日期',
	Exchange_rate_type: '汇率类型',
	Amount: '金额',
	unit_price: '单价',
	Quantity: '数量',
	unit: '单位',
	Demand_level: '需求等级',
	Approval_history: '审批历史记录',
	Serial_number: '序号',
	Handler: '处理人',
	post: '岗位',
	opinion: '意见',
	Processing_time: '处理时间',
	time_consuming: '耗时',
	Comment_information: '评论信息',
	Purchase_prices: '采购单价',
	Our_main_body: '我方主体',
	Handling_department: '经办部门',
	Purchasing_suppliers: '采购供应商',
	Supplier_Acquiring_Email: '供应商收单邮箱',
	tax_rate: '税率',
	Associated_contract: '关联合同',
	payment_terms: '付款条件',
	select_all: '全选',
	Please_enter_the_content_the_number_of_words_does_not_exceed_1000: '请输入内容，字数不超过1000'
};
